import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api-data.service';
import { CommonService } from 'src/app/services/common.service';
import { ToastrService } from 'ngx-toastr';
import { URLS } from 'src/app/_config/api.config';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss']
})
export class ArticlesComponent implements OnInit {
 
  constructor(private router: Router,
      private commonService: CommonService,
      private dataService: ApiService,
      private toastr: ToastrService,
      @Inject(DOCUMENT) private document: any,
      @Inject(PLATFORM_ID) private platformId: Object
  ) { }
  cards: any[] = [];
  filteredCards: any[] = [];
  searchText: string = '';
  selectedCategory: string = '';
  uniqueCategories: any[] = [];
  isLoading=false;
  displayLoadMore=true;
  pageCount=1;
  private subscription: Subscription = new Subscription();

  ngOnInit() {
   if (isPlatformBrowser(this.platformId)) {
        if (this.router.url === '/resources') {
          var elems = this.document.getElementsByClassName('resources')[0];
          if (elems != null) {
              elems.classList.remove("active");
          }
          elems.className = "active";
      }
      if (this.router.url === '/about-us') {
          var elem1 = this.document.getElementsByClassName('aboutUs')[0];
          if (elem1 != null) {
              elem1.classList.remove("active");
          }
          elem1.className = "active";
      }
      // Release5 Article menu revert
      if (this.router.url === '/articles') {
          var elem2 = this.document.getElementsByClassName('articles')[0];
          if (elem2 != null) {
              elem2.classList.remove("active");
          }
          elem2.className = "active";
      }
    }
      
    this.filteredCards = [...this.cards]; // Initially, all cards are displayed
    this.uniqueCategories = [...new Set(this.cards.map(card => card.category))]; // Get unique categories
    this.getArticles();
    this.getCategories();
    this.selectedCategory=null;
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  getCategories(){
    // this.isLoading=true
    this.subscription.add(
      this.dataService.get(URLS.articleCategory).subscribe(res => {
          if (res && res['code'] == 200) {
              // this.isLoading = false;
              // this.notification.success('Success', res['message']);
              this.uniqueCategories=res['data']
              // this.thumbnailKey = res['data']['thumbnailKey'];
          } else {
              // this.isLoading = false;
              this.toastr.error('Error', res['message']);
          }
      }, error => {
          // this.isLoading = false;
          this.toastr.error('Error', error['message']);
      }
      )
  )
  }

  applyFilters() {
    let params={}
    params['articleCategoryType']=this.selectedCategory;
    if(this.searchText && this.searchText.length>0)
      params['search']= this.searchText;
    this.getListData(params);
  }

  searchApi(){  
    let params={}
    params['search']= this.searchText;
    if(this.selectedCategory != null)
      params['articleCategoryType']=this.selectedCategory;
    this.getListData(params);
  }

  handleKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Delete'];
  
    if (allowedKeys.includes(event.key) && this.searchText.length==1) {
      this.getArticles();
    }
  }

  getListData(params?) {
    this.isLoading = true;
    this.subscription.add(
        this.dataService.get(URLS.getArticle, params).subscribe(
            data => {
                if (data['code'] == 200) {
                    this.cards = data['data']['result'];
                    // this.totalCount = data['data']['totalCount'];
                      this.displayLoadMore=false
                    this.isLoading = false;
                } else {
                    this.isLoading = false;
                    this.toastr.error('Error', data['message']);
                }
            },
            error => {
                this.isLoading = false;
                console.log(error);
            }
        )
    );
}

  onHome() {
    this.router.navigateByUrl('/');
  }

  getArticles(page?) {
    this.isLoading=true
    let pageNo = 1;
    if(page)
      pageNo=page;
    else{
    this.pageCount=1;
    }
    this.subscription.add(
      this.dataService.get(URLS.getArticle+`?page=${pageNo}&size=6`).subscribe(data => {
        if (data['code'] == 200) {
          // this.articleData = data['data']['result'];
          if (pageNo == 1) {
            this.cards = [...data['data']['result']];
            if (this.cards.length != data['data']['totalCount']) {
              this.displayLoadMore = true;
            }
          }
          else if(this.cards.length != data['data']['totalCount']){
            this.cards = [...this.cards, ...data['data']['result']];
            setTimeout(() => {
              window.scrollTo({ top: document.body.scrollHeight - 1000, behavior: 'smooth' });
            }, 100);
          }
          // this.cards.push(...data['data']['result']);
         
          if(this.cards.length == data['data']['totalCount']){
            this.displayLoadMore=false
          }
          this.isLoading=false;
        
        } else {
          this.toastr.error(data['message'], "Error");
          this.isLoading=false;
        }
      }, error => {
        this.toastr.error(error['message'], "Error");
        this.isLoading=false;
      })
    )

  }

  loadMore(){
    this.pageCount =this.pageCount +1;
    this.getArticles(this.pageCount);
    setTimeout(() => {
      window.scrollTo(0, scrollY); // Restore scroll position
    }, 100);
  }

  readMore(data) {
    if (data.authorName) {
      // const formattedTitle = data.title.replace(/\s+/g, '-');
      const formattedTitle = data.title.replace(/[^a-zA-Z0-9- ]/g, '').replace(/\s+/g, '-');
      // const formattedTitle = data.title.replace(/\?/g, '').replace(/\s+/g, '-');    
      this.router.navigate(['articles/', formattedTitle.toLowerCase()]);
    }
    else
    window.open(data.url, '_blank');
  }  

  // readMore(data) {
  //   const formattedTitle = data.title.replace(/\?/g, '').replace(/\s+/g, '-');
  
  //   // Navigate using the formatted title and the article ID as a query param
  //   if (data.authorName) {
  //     this.router.navigate(['articles', formattedTitle.toLowerCase()], {
  //       queryParams: { id: data._id } // Add the article's ID as query param
  //     });
  //   } else {
  //     window.open(data.url, '_blank');
  //   }
  // }

  clearSearch() {
    this.searchText = null;
    if (this.selectedCategory != null) {
      let params = {}
      params['articleCategoryType'] = this.selectedCategory;
      this.getListData(params);
    } else
    this.getArticles();
  }

  clearSelect(){
    this.selectedCategory=null;
    if(this.searchText && this.searchText.length>0) {
      let params={}
      params['articleCategoryType']=this.selectedCategory;
      this.getListData(params);
    }
    else
    this.getArticles();
  }

  removeHtmlTags(input: string): string {
    // if (typeof input !== 'string') {
    //   return ''; // Handle non-string input
    // }

    // // Remove HTML tags
    // let text = input.replace(/<\/?[^>]+(>|$)/g, '');
    // text= text.replace(/&nbsp;/g,'');
    // // Decode HTML entities
    // const textarea = document.createElement("textarea");
    // textarea.innerHTML = text;
    // return textarea.value;
    if (typeof input !== 'string') {
      return ''; // Handle non-string input
    }
    input = input.replace(/^(<br\s*\/?>|\s)*/i, '');
  
    const matches = [...input.matchAll(/<p[^>]*>([\s\S]*?)<\/p>/gi)];
    let firstPContent = matches.length > 0 ? matches[0][1] : '';
    input=input.replace(firstPContent, '');
    firstPContent=firstPContent.replace(/<\/?[^>]+(>|$)/g, '')
    firstPContent=firstPContent.replace(/&nbsp;/g, '');
    // Remove HTML tags
    let text = input.replace(/<\/?[^>]+(>|$)/g, '');
    text = text.replace(/&nbsp;/g, '');
  
    if (isPlatformBrowser(this.platformId)) {
      // Decode HTML entities
      const textarea = document.createElement("textarea");
      textarea.innerHTML = firstPContent + ' ' + text;
      return textarea.value.trim();
    }
  }

  trackByFn(index: number, item: any): any {
    return item._id; // Use a unique identifier (like ID) to track items
  }

}
